import { gql } from '@apollo/client';

export const IS_SUPERUSER = gql`
  query IsSuperuser {
    isSuperuser
    adminCheck
  }
`;

export const GET_USER_ACTIVITIES = gql`
  query GetUserActivities($limit: Int) {
    userActivities(limit: $limit) {
      id
      user {
        id
        username
        email
      }
      publisher {
        id
        name
      }
      actionType
      actionDetails
      created
    }
  }
`;

export const GET_RECENT_VISITORS = gql`
  query GetRecentVisitors($limit: Int) {
    recentVisitors(limit: $limit) {
      id
      user {
        id
        username
        email
        firstName
        lastName
      }
      publisher {
        id
        name
      }
      actionType
      actionDetails
      created
      ipAddress
      userAgent
    }
  }
`;

export const GET_RECENT_PRODUCTS = gql`
  query GetRecentProducts($limit: Int) {
    recentProducts(limit: $limit) {
      id
      productWork {
        id
        title
      }
      isbn
      publisher {
        id
        name
      }
      retailPrice
      coverImage
      created
    }
  }
`;

export const GET_RECENT_CUSTOMERS = gql`
  query GetRecentCustomers($limit: Int) {
    recentCustomers(limit: $limit) {
      id
      firstName
      lastName
      company
      publisher {
        id
        name
      }
      created
    }
  }
`;

export const GET_SYSTEM_STATS = gql`
  query GetSystemStats {
    systemStats
  }
`;

export const GET_PUBLISHER_STATS = gql`
  query GetPublisherStats($publisherId: ID!) {
    publisherStats(publisherId: $publisherId)
  }
`;

export const SEARCH_PUBLISHERS = gql`
  query SearchPublishers($searchTerm: String!, $limit: Int) {
    publisherSearch(searchTerm: $searchTerm, limit: $limit) {
      id
      name
      lastLogin
      lastActivity
      lastActivityType
    }
  }
`;

export const CONTACT_PUBLISHER = gql`
  mutation ContactPublisher($publisherId: ID!, $message: String!, $subject: String) {
    contactPublisher(publisherId: $publisherId, message: $message, subject: $subject)
  }
`;

export const RESET_PUBLISHER_PASSWORD = gql`
  mutation ResetPublisherPassword($publisherId: ID!, $userId: Int) {
    resetPublisherPassword(publisherId: $publisherId, userId: $userId) {
      success
    }
  }
`;

export const DELETE_PUBLISHER = gql`
  mutation DeletePublisher($id: Int!) {
    deletePublisher(id: $id) {
      success
    }
  }
`;

export const GET_SYSTEM_PERFORMANCE = gql`
  query GetSystemPerformance($days: Int) {
    systemPerformance(days: $days)
  }
`;

export const GET_GRAPHQL_PERFORMANCE = gql`
  query GetGraphQLPerformance($days: Int) {
    graphqlPerformance(days: $days)
  }
`;

export const GET_FAILED_LOGINS = gql`
  query GetFailedLogins($days: Int) {
    failedLogins(days: $days)
  }
`;

export const GET_RECENT_SIGNUPS = gql`
  query GetRecentSignups($limit: Int) {
    recentSignups(limit: $limit) {
      id
      username
      email
      firstName
      lastName
      publisheruserSet {
        id
        publisher {
          id
          name
        }
        created
      }
    }
  }
`;

export const GET_RECENT_SUBSCRIPTIONS = gql`
  query GetRecentSubscriptions($limit: Int) {
    recentSubscriptions(limit: $limit) {
      id
      name
      billingActive
      billingDate
      plan
      created
    }
  }
`;

export const GET_PUBLISHER_ACTIVITIES = gql`
  query GetPublisherActivities($publisherId: ID!) {
    userActivities(publisher_id: $publisherId, limit: 50) {
      id
      user {
        id
        username
        email
        firstName
        lastName
      }
      publisher {
        id
        name
      }
      actionType
      actionDetails
      created
      ipAddress
      userAgent
    }
  }
`;

export const GET_INACTIVE_USERS = gql`
  query GetInactiveUsers($period: String!) {
    inactiveUsers(period: $period) {
      id
      username
      email
      firstName
      lastName
      lastLogin
      publisheruserSet {
        id
        publisher {
          id
          name
        }
      }
    }
  }
`;
